import { HorizontalAlign, VerticalAlign } from "@pdfking/renderer-api"

import type { MonthLayout } from "#internal"

// The rows a month's days take on their weekdays': a 31st six days on
export const WEEK_ROWS = 37

/** A month's grid as the large calendars set it: its box split in its cells,
 * the weekdays' short names, the months either side muted, ruled, no title. */
export const MONTH_LAYOUT: MonthLayout = {
  font: undefined,
  horizontal_align: HorizontalAlign.CENTER,
  height: undefined,
  initials: false,
  muted: true,
  rules: true,
  title: "none",
  title_scale: 1,
  vertical_align: VerticalAlign.CENTER,
  width: undefined,
}

// The address and the contacts, as the shop's templates have them
export const ADDRESS = ["Via G. Garibaldi, 12", "00144 Roma", "Tel. 06.010203"]
export const CONTACTS = ["info@yourlogo.com", "www.yourlogo.com"]
